/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const WorkInstructionWarningReason = {
    TallyNotConfirmed: 'TallyNotConfirmed',
    LinkedInboundNotFinished: 'LinkedInboundNotFinished',
    CarrierNotReadyForOperation: 'CarrierNotReadyForOperation',
    OnYardWithoutPosition: 'OnYardWithoutPosition',
    StuffingAndContainerCriticallyDamaged: 'StuffingAndContainerCriticallyDamaged',
    RequiresReservation: 'RequiresReservation',
    FutureOutbound: 'FutureOutbound',
    RequiresPlugOut: 'RequiresPlugOut',
    LinkedInboundForceFinishedByGateOutWithoutLocation: 'LinkedInboundForceFinishedByGateOutWithoutLocation',
    LoadingApprovalMissing: 'LoadingApprovalMissing',
    WorkInstructionStopped: 'WorkInstructionStopped',
    DischargeApprovalMissing: 'DischargeApprovalMissing',
    ExpiredRelease: 'ExpiredRelease',
} as const;

export type WorkInstructionWarningReason = typeof WorkInstructionWarningReason[keyof typeof WorkInstructionWarningReason];



